import { api } from "@/api";

export async function getUserTimezones(upn: string): Promise<any> {
  const res = await api.timezones(upn);
  return res;
}

export async function saveUserTimezones(payload: any): Promise<any> {
  const res = await api.saveTimezones(payload);
  return res;
}

export async function getTimezoneConfig(): Promise<any> {
  const res = await api.timezoneConfig();
  return res;
}

export async function updateTimezoneConfig(payload: {
  items: {
    Id: number;
    OfficeStartHour: number;
    OfficeEndHour: number;
  }[];
}): Promise<any> {
  const res = await api.timezoneConfigUpdate(payload);
  return res;
}